interface SelectedManualAdjustmentRow {
  manualAdjustment: { id: string };
}

// ag-grid hands back `node.data` for every selected node, which is `undefined`
// for group rows (e.g. when this table is grouped by business) — filter those out.
export function getSelectedManualAdjustmentIds(
  selectedRows: Array<SelectedManualAdjustmentRow | undefined>,
): string[] {
  return selectedRows
    .filter(
      (row): row is SelectedManualAdjustmentRow => !!row?.manualAdjustment,
    )
    .map(row => row.manualAdjustment.id);
}
